module.exports = __webpack_public_path__ + "img/claim_btn.db7bcf8d.png";